export default "__VITE_ASSET__722b49b7__"